import Backbone from "backbone";
import {isFnacPro} from "../others/Configuration";
import $ from "jquery";
import PopoverTopVendorViewTemplate from "./PopoverTopVendorView.mustache"


export default Backbone.View.extend({
    initialize: function () {
      this.isLoaded = false;
      this.isActive = false;

      this.initContent();
    },

    events: {
      "mouseenter .js-popoverTopVendor-show": "showTopVendorContent",
      "mouseenter .js-popoverTopVendor-container": "showTopVendorContent",
      "mouseleave .js-popoverTopVendor-container": "removeTopVendorContent",
      "mouseleave .f-popover": "removeTopVendorContent",
      // added just for the new fa cuz we have to keep retro-compatibility
      "mouseleave": "newFARemoveTopVendorContent",
      "click .js-popoverTopVendor-show": "newFAShowTopVendorContent",
      // end
    },

    initContent: function () {
      this.$topVendorContainer = this.$(".js-popoverTopVendor-container");
      this.$topVendorContainer.html(PopoverTopVendorViewTemplate.render());
      this.isLoaded = true;

      // added just for the new fa cuz we have to keep retro-compatibility
      this.isNewFa = !!this.$el.hasClass("js-popoverTopVendor--newFA");
      // end
    },

    showTopVendorContent: function (e, active) {
      // added just for the new fa cuz we have to keep retro-compatibility
      if (this.isNewFa && !active) {
        return;
      }
      // end

      if (!this.isLoaded) {
        this.initContent();
      }
      if (!this.isActive) {
        this.$topVendorContainer.addClass("isActive");
        this.isActive = true;
      }
    },

    removeTopVendorContent: function (e) {
      this.$topVendorContainer.removeClass("isActive");
      this.isActive = false;
    },

    // added just for the new fa cuz we have to keep retro-compatibility
    newFAShowTopVendorContent: function(e) {
      if (this.isNewFa) {
        this.showTopVendorContent(e, true);
      }
    },

    newFARemoveTopVendorContent: function() {
      if (this.isNewFa) {
        this.removeTopVendorContent();
      }
    }
    // end

  });
